import { Button, Flex, Icon, Input, InputGroup, InputLeftAddon, Select, TableContainer, Text } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import * as T from '../../../components/Table'
import { Producao360List } from './Producao360List'
import { FaSearch } from 'react-icons/fa'
import { useForm } from 'react-hook-form'
import { useProducao360Context } from '../../../contexts/Producao360Provider'
import { ModalInicialFiltro } from './ModalInicialFiltro'
import { useState } from 'react'

export function Producao360() {
  const form = useForm()
  const { setFormValues, query } = useProducao360Context()
  const { register, handleSubmit } = form
  const [isCompreGanhe, setIsCompreGanhe] = useState(false)

  const { isLoading, isRefetching, data } = query

  async function handleSubmitFilter(data) {
    const { pedido, pendente } = data

    setFormValues({ pedido, pendente })
  }

  return (
    <>
      <HeadingPages name="Produção 360" />

      <ModalInicialFiltro isCompreganhe={isCompreGanhe} setIsCompreGanhe={setIsCompreGanhe} />

      <Flex flexDir="column" gap={5} maxW="1341px" mx="auto" px={5}>
        <Flex alignItems="center" justifyContent="center" gap={2} bg={'#EDF2F7'} py={'14px'}>
          <Text as="span" color="#378BBF">
            Quantidade itens:{' '}
            <Text as="strong" color="black">
              {data?.quantidade_itens}
            </Text>
          </Text>
          <Text as="span" color="#378BBF">
            Faltam:{' '}
            <Text as="strong" color="#FF0000">
              {data?.total_pendentes}
            </Text>
          </Text>
        </Flex>
        <Flex alignItems="flex-end" gap={5}>
          <Flex as="form" alignItems="flex-end" gap={5} w="full" maxW="626px" mx="auto" onSubmit={handleSubmit(handleSubmitFilter)}>
            <InputGroup size="sm">
              <InputLeftAddon children="Pesquisar pedido" as="label" htmlFor="pedido" />
              <Input id="pedido" type={'pedido'} placeholder={'Pedido'} {...register('pedido')} />
            </InputGroup>

            <InputGroup size="sm">
              <InputLeftAddon children="Pendente" as="label" htmlFor="pendente" />
              <Select id="pendente" size="sm" borderLeftRadius={0} placeholder="Selecione" {...register('pendente')}>
                <option value="true">Pendente</option>
                <option value="false">Não pendente</option>
              </Select>
            </InputGroup>

            <Button
              fontSize="12px"
              fontWeight="normal"
              size="sm"
              maxW="147px"
              bgColor="#378BBF"
              w="100%"
              type="submit"
              colorScheme="blue"
              leftIcon={<Icon as={FaSearch} />}
              isLoading={isLoading || isRefetching}
            >
              Filtrar
            </Button>
          </Flex>
        </Flex>

        <TableContainer>
          <T.Table>
            <T.Thead>
              <T.Tr>
                <T.Th textAlign="start" px={3}>
                  Produto
                </T.Th>
                <T.Th>Pedido</T.Th>
                <T.Th>
                  Quantidade <br /> por Layout
                </T.Th>
                <T.Th>Nome</T.Th>
                <T.Th>Nome do Arquivo</T.Th>
                <T.Th>Layout</T.Th>
                <T.Th>Data e hora inicio</T.Th>
                <T.Th>Data e hora termino</T.Th>
                <T.Th>Link base</T.Th>
              </T.Tr>
            </T.Thead>
            <T.Tbody>
              <Producao360List />
            </T.Tbody>
          </T.Table>
        </TableContainer>
      </Flex>
    </>
  )
}
